<template>
  <li class="nav-item dropdown">
    <a href="#" class="nav-link d-flex align-items-center gap-2" data-bs-toggle="dropdown"
       v-bs-dropdown-fixed @click.prevent="onToggleClick" role="button" aria-expanded="false">
      <template v-if="activeTask">
        <div style="width: 80px">
          <b-progress :max="activeTask.progress.of" style="height: 6px">
            <b-progress-bar :value="activeTask.progress.sheet" class="bg-success"></b-progress-bar>
          </b-progress>
        </div>
        <small class="text-nowrap">{{ activeTask.progress.sheet }}/{{ activeTask.progress.of }}</small>
      </template>
      <i v-else class="fa fa-download"></i>
    </a>
    <ul class="dropdown-menu dropdown-menu-end p-2" style="min-width: 360px; max-height: 420px; overflow-y: auto">
      <li v-if="list.length === 0" class="px-2 py-3 text-center text-muted">
        {{ helper.trans('export_tasks.empty') }}
      </li>
      <li v-for="(task, index) in list" :key="task.id" :class="{'border-bottom': index < list.length - 1}">
        <ExportTaskListItem :task="task" class="px-2"></ExportTaskListItem>
      </li>
    </ul>
  </li>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, onUnmounted} from 'vue'
import {useStore} from 'vuex';
import {helper} from "@/service/CommonHelper";
import ExportTaskListItem from "@/components/ExportTaskListItem.vue";

export default defineComponent({
  components: {ExportTaskListItem},
  setup() {
    const store = useStore();

    const list = computed(() => store.getters['exportTasks/list']);
    const activeTask = computed(() => store.getters['exportTasks/activeTask']);

    const onToggleClick = () => {
      store.dispatch('exportTasks/loadList');
    };

    onMounted(async () => {
      try {
        await store.dispatch('exportTasks/loadList');
      } catch (e) {
        return;
      }

      if (store.getters['exportTasks/activeTask']) {
        store.dispatch('exportTasks/startPolling');
      }
    });

    onUnmounted(() => {
      store.dispatch('exportTasks/stopPolling');
    });

    return {
      helper,
      list,
      activeTask,
      onToggleClick,
    }
  }
})
</script>
